import {
    UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_SUCCESS,
    UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_FAILED,
    RESET_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER,
    LOADING_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER,
    NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";


const resetUpdateGatewayTransaction = () => {
    return { type: RESET_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER };
};

const partnerUpdateGatewayTransactions = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER });
    await partnerServices
        .post("updateGatewayTransactionStatus", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch(UpdateGatewayTranssuccess(res.data));
                    break;
                case "success":
                    dispatch(UpdateGatewayTranssuccess(res.data));
                    break;
                default:
                    dispatch(UpdateGatewayTransFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER, payload: err });
        });
};
function UpdateGatewayTranssuccess(data) {
    return {
        type: UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_SUCCESS,
        payload: data,
    };
}
function UpdateGatewayTransFailed(data) {
    return {
        type: UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_FAILED,
        payload: data,
    };
}

export { resetUpdateGatewayTransaction, partnerUpdateGatewayTransactions };
